export const buildContactSeo = (seo, ...parts) => {
  const title = buildContactTitle(...parts);

  if (!title) {
    return seo;
  }

  return {
    ...seo,
    metaTitle: title,
  };
};

export const buildContactTitle = (...parts) => {
  const titleParts = parts.map((part) => part?.attributes?.name?.trim()).filter(Boolean);

  if (titleParts.length === 0) {
    return null;
  }

  return ['Kontakt', ...titleParts].join(' – ');
};
